import { useLayoutEffect, useRef, useMemo } from "react";
import WorkItem from "./WorkItem";
import { gsap } from "gsap";

const WorkItemContainer = ({ lang, containerTitle, items, onUrlClick, selectedCategory }) => {
    const containerRef = useRef(null);
    const itemsRef = useRef(new Map());

    // 1) 필터링된 아이템 리스트
    const filteredItems = useMemo(() => {
        if (!Array.isArray(items)) return [];
        return selectedCategory === "all"
            ? items
            : items.filter((item) => item.categorys.includes(selectedCategory));
    }, [items, selectedCategory]);

    useLayoutEffect(() => {
        requestAnimationFrame(() => {
            // 1️⃣ 기존 진행 중인 애니메이션 정리
            gsap.killTweensOf([...itemsRef.current.values()]);

            // 2️⃣ 모든 아이템 초기 상태 설정 (미리 보이는 문제 방지)
            filteredItems.forEach((item) => {
                const node = itemsRef.current.get(item.url);
                if (!node) return;
                gsap.set(node, { opacity: 0, y: 20, scale: 0.95 }); // 등장 전 숨김 처리
            });

            // 3️⃣ 애니메이션 적용 (순차적 등장)
            filteredItems.forEach((item, index) => {
                const node = itemsRef.current.get(item.url);
                if (!node) return;

                gsap.to(node, {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.7,
                    ease: "back.inOut(1.5)",
                    delay: index * 0.1, // 순차 등장 효과
                });
            });
        });
    }, [filteredItems]);

    return (
        <div id={containerTitle} className="work-item-container" ref={containerRef}>
            <div className="work-item-container_list">
                {filteredItems.map((item, index) => (
                    <WorkItem
                        key={(item.url?.[lang] || item.url) || `${item.title?.[lang] || item.title}-${index}`}
                        ref={(el) => itemsRef.current.set(item.url?.[lang] || item.url, el)}
                        url={item.url?.[lang] || item.url}
                        imgURL={item.imgURL}
                        title={item.title?.[lang] || item.title}
                        onUrlClick={onUrlClick}
                        client={item.client}
                        tags={item.tags}
                        categorys={item.categorys}
                        featured={selectedCategory === "all"
                            ? item.featured
                            : item.featured === "large"
                                ? "small"
                                : item.featured}
                        award={item.award}
                    />
                ))}
            </div>
        </div>
    );
};

export default WorkItemContainer;